import PropTypes from 'prop-types';
import { DoubleSlider } from '@bwoty-web/styleguide';
import CheckboxFilter from '../../shared/filterComponents/CheckboxFilter';
import DestinationFilter from './DestinationFilter';
import RatingFilter from './RatingFilter';
import './filterGroup.scss';

const FilterGroup = ({
  filterGroup,
  filterActions,
  filterMatches,
  filterPanelIsOpen,
  siteId,
}) => {
  const filterGroupMarkup = [];

  const hasLessThanTwoOptions = !filterGroup.options || filterGroup.options?.length < 2;
  const minAndMaxValuesAreSame = filterGroup.minValue != null && filterGroup.maxValue != null && filterGroup.minValue === filterGroup.maxValue;

  if (hasLessThanTwoOptions || minAndMaxValuesAreSame) {
    return null;
  }

  filterGroupMarkup.push(
    <h3
      className="iw-cruise-filter-group__heading"
      key={`filterGroupHeading_${filterGroup.id}`}
    >
      {filterGroup.heading}
    </h3>,
  );

  switch (filterGroup.id) {
    case 'departureMonth':
      filterGroupMarkup.push(
        <CheckboxFilter
          id={filterGroup.id}
          options={filterGroup.options}
          matches={filterMatches.departureMonth}
          selected={filterGroup.selected}
          onChange={filterActions.selectFilterDepartureMonth}
          key={filterGroup.id}
        />,
      );
      break;
    case 'shipRating':
      filterGroupMarkup.push(
        <RatingFilter
          id={filterGroup.id}
          siteId={siteId}
          options={filterGroup.options}
          matches={filterMatches.shipRating}
          selected={filterGroup.selected}
          onChange={filterActions.selectFilterShipRating}
          key={filterGroup.id}
        />,
      );
      break;
    case 'duration':
      filterGroupMarkup.push(
        <DoubleSlider
          hidden={!filterPanelIsOpen}
          uniqueId={filterGroup.id}
          key={filterGroup.id}
          filterSliderToLabel={filterGroup.toLabel}
          filterSingularUnitLabel={filterGroup.dayLabel}
          filterPluralUnitLabel={filterGroup.daysLabel}
          minValue={filterGroup.minValue}
          maxValue={filterGroup.maxValue}
          selectedLowValue={filterGroup.selectedMinValue != null ? filterGroup.selectedMinValue : filterGroup.minValue}
          selectedHighValue={filterGroup.selectedMaxValue != null ? filterGroup.selectedMaxValue : filterGroup.maxValue}
          onChangeComplete={(values) =>
            filterActions.selectFilterDuration(
              values.lowValue,
              values.highValue,
            )
          }
        />,
      );
      break;
    case 'cruiseCategory':
      filterGroupMarkup.push(
        <CheckboxFilter
          id={filterGroup.id}
          options={filterGroup.options}
          matches={filterMatches.cruiseCategory}
          selected={filterGroup.selected}
          onChange={filterActions.selectFilterCruiseCategory}
          key={filterGroup.id}
        />,
      );
      break;
    case 'destination':
      filterGroupMarkup.push(
        <DestinationFilter
          filterGroup={filterGroup}
          matches={filterMatches.destination}
          selectDestination={filterActions.selectFilterDestination}
          selectNumberOfDestinations={filterActions.selectFilterNumberOfDestinations}
          filterPanelIsOpen={filterPanelIsOpen}
          key={filterGroup.id}
        />,
      );
      break;
    case 'shippingCompany':
      filterGroupMarkup.push(
        <CheckboxFilter
          id={filterGroup.id}
          options={filterGroup.options}
          matches={filterMatches.shippingCompany}
          selected={filterGroup.selected}
          onChange={filterActions.selectFilterShippingCompany}
          key={filterGroup.id}
        />,
      );
      break;
    default:
      break;
  }
  return (
    <div className="iw-cruise-filter-group" key={filterGroup.order}>
      {filterGroupMarkup}
    </div>
  );
};

FilterGroup.propTypes = {
  filterGroup: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape()),
    order: PropTypes.number.isRequired,
    selected: PropTypes.arrayOf(PropTypes.number),
    selectedMinValue: PropTypes.number,
    selectedMaxValue: PropTypes.number,
    toLabel: PropTypes.string,
    dayLabel: PropTypes.string,
    daysLabel: PropTypes.string,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
  }).isRequired,
  filterActions: PropTypes.shape({
    selectFilterDepartureMonth: PropTypes.func.isRequired,
    selectFilterShipRating: PropTypes.func.isRequired,
    selectFilterDuration: PropTypes.func.isRequired,
    selectFilterCruiseCategory: PropTypes.func.isRequired,
    selectFilterDestination: PropTypes.func.isRequired,
    selectFilterNumberOfDestinations: PropTypes.func.isRequired,
    selectFilterShippingCompany: PropTypes.func.isRequired,
  }).isRequired,
  filterMatches: PropTypes.shape({
    departureMonth: PropTypes.shape().isRequired,
    shipRating: PropTypes.shape().isRequired,
    cruiseCategory: PropTypes.shape().isRequired,
    destination: PropTypes.shape().isRequired,
    shippingCompany: PropTypes.shape().isRequired,
  }).isRequired,
  filterPanelIsOpen: PropTypes.bool.isRequired,
  siteId: PropTypes.number.isRequired,
};

export default FilterGroup;
